import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { Footer } from '../../../components/Landing/Footer';
import { Header } from '../../../components/Landing/Header/haeder.view';
import { BepsForms } from './components/BepsForms/beps-forms.view';
import { HeroBeps } from './components/HeroBeps/hero-beps.view';

export const Beps = () => {

    const navigate = useNavigate();

    useEffect(() => {
        logueado()
    }, [])
    
    const logueado = () => {
        if(localStorage.token != undefined){
           
        }else{
        navigate("/login");
        }
}


    return (
       <>
            <Header />
            <HeroBeps />
            <BepsForms />
            <Footer />
       </>
    )
}
